import { createReducer, createTypes } from 'reduxsauce';

export const iotTypes = createTypes(
  `
    SET_VARIABLES_THING
    SET_VALUES_THING
  `,
  { prefix: 'IOT/' }
);

const INITIAL_STATE = {};

const setVariablesThing = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    [action.thingName]: {
      ...state[action.thingName],
      variables: action.variables,
    },
  };
};

const setValuesThing = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    [action.thingName]: {
      ...state[action.thingName],
      values: action.values,
      unsubscribe: action.unsubscribe,
    },
  };
};

export default createReducer(INITIAL_STATE, {
  [iotTypes.SET_VARIABLES_THING]: setVariablesThing,
  [iotTypes.SET_VALUES_THING]: setValuesThing,
});
